@if (isMobile()) {
  <app-header
    [transparent]="false"
    [title]="
      asset()
        ? !Sensor()
          ? i18n.parse(asset()?.objectName)
          : i18n.langString('equipment_status')
        : i18n.langString('asset')
    "
    [backRoute]="!!asset() ? '' : ''"
  >
  </app-header>
}

@if (loading()) {
  <div class="spinner-container" [class.desktop]="isDesktop()">
    <app-spinner [black]="true"></app-spinner>
  </div>
}

<div
  class="content"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
  [class.desktop]="isDesktop()"
  [class.sensorView]="Sensor()"
>
  @if (isDesktop()) {
    <div class="desktop-sidebar white-sidebar">
      <app-sidebar
        [showList]="true"
        [asset]="asset()"
        [sensorID]="selectedSensor()"
        [loading]="loading()"
      >
      </app-sidebar>
    </div>
  }
  @if (!loading()) {
    <div
      [class.desktop-main]="isDesktop()"
      [class.white-sidebar-main]="isDesktop()"
    >
      @if (
        !isDesktop() &&
        !!asset() &&
        asset()?.breadcrumbs &&
        !breadcrumbsLoading()
      ) {
        <app-breadcrumbs
          [array]="Breadcrumbs()"
          [isAsset]="true"
          class="detail-bold"
        >
        </app-breadcrumbs>
      }

      @if (asset() && breadcrumbsLoading()) {
        <app-spinner class="crumbs-spinner" [black]="true"></app-spinner>
      }

      @if (asset() && !Sensor()) {
        <h1 class="asset-name">{{ asset()?.objectName }}</h1>
        <p class="asset-overview-subtitle">AssetID# {{ asset()?.objectID }}</p>
      }

      @if (
        asset() && Sensor() && !isDesktop() && asset()?.equipmentTypeID !== 113
      ) {
        <div class="sensor-header flat-sensor sensor-header-title">
          @if (SensorDetailedTelemetry()) {
            <div class="sensor-header-inner-div">
              <h1>{{ Sensor()?.sensorDisplayLabel }}</h1>
            </div>
          } @else {
            @if (Sensor()?.telemetry?.[0]) {
              <i
                nz-icon
                [nzType]="'icons:' + Sensor()?.telemetry?.[0]?.svg"
                class="sensor-icon svg-icon"
              >
              </i>
            }
            <div class="sensor-header-inner-div">
              <h2>{{ i18n.parse(Sensor()?.telemetry?.[0]?.title) }}</h2>
              <span class="detail lighter-label">{{
                Sensor()?.sensorDisplayLabel
              }}</span>
            </div>
          }
        </div>
      }

      @if (
        asset() && Sensor() && isDesktop() && asset()?.equipmentTypeID !== 113
      ) {
        <div
          class="asset-back-btn"
          role="button"
          tabindex="0"
          (click)="onSensorDeselect()"
          (keydown.enter)="onSensorDeselect()"
          (keydown.space)="onSensorDeselect()"
        >
          <i
            nz-icon
            [nzType]="'icons:arrow-left'"
            class="svg-icon fillwhite"
          ></i>
          <span>
            {{
              i18n.langString("back_to") + i18n.parse(asset()?.objectName ?? "")
            }}
          </span>
        </div>

        @if (SensorDetailedTelemetry()) {
          <div class="sensor-header assetID">
            <h2>{{ i18n.parse(Sensor()?.sensorDisplayLabel ?? "") }}</h2>
          </div>
          <p class="asset-overview-subtitle">
            AssetID# {{ asset()?.objectID ?? "" }}
          </p>
        } @else {
          <h2 class="sensorViewTitle">
            {{ Sensor()?.sensorDisplayLabel ?? "" }}
          </h2>
        }
      }
      @if (error()) {
        <h1>{{ i18n.langString("asset_not_found") }}</h1>
      }

      <div class="header-img-container">
        @if (asset() && asset()?.picture) {
          <img
            nz-image
            nzDisablePreview
            class="header-img"
            [class.hiddenPicture]="thumbnailLoading() || thumbnailError()"
            [nzSrc]="asset()?.picture ?? ''"
            alt="Asset"
            role="button"
            tabindex="0"
            (click)="onHeaderImageClick()"
            (keydown.enter)="onHeaderImageClick()"
            (keydown.space)="onHeaderImageClick()"
            (load)="onThumbnailLoaded($event)"
            (error)="onThumbnailLoadFailed()"
          />
        }

        @for (marker of sensorMarkers(); track trackByMarker($index, marker)) {
          <div
            class="sensor-marker-wrapper"
            [ngStyle]="{ 'left.px': marker.x, 'top.px': marker.y }"
          >
            <div
              class="sensor-marker"
              role="button"
              tabindex="0"
              [class.longtext]="marker.text.length > 4"
              [class.warning]="marker.warning"
              [class.critical]="marker.critical"
              [class.inactive]="marker.inactive"
              [class.nodata]="marker.nodata"
              [class.selected]="marker.selected"
              [class.hidden]="marker.hidden"
              (click)="onSensorSelect(marker.sensorID)"
              (keydown.enter)="onSensorSelect(marker.sensorID)"
              (keydown.space)="onSensorSelect(marker.sensorID)"
            >
              <span>{{ marker.text }}</span>

              @if (marker.critical) {
                <div class="alarm-marker">
                  <i
                    nz-icon
                    [nzType]="'icons:status-exclamation-triangle'"
                    class="mini-svg-icon fillwhite"
                  ></i>
                </div>
              }

              @if (marker.warning) {
                <div class="warning-marker">
                  <i
                    nz-icon
                    [nzType]="'icons:status-exclamation-octagon'"
                    class="mini-svg-icon"
                  ></i>
                </div>
              }

              @if (marker.inactive) {
                <div class="inactive-marker">
                  <i
                    nz-icon
                    [nzType]="'icons:cross-circle'"
                    class="svg-icon fillwhite"
                  ></i>
                </div>
              }

              @if (
                !marker.critical &&
                !marker.warning &&
                !marker.inactive &&
                marker.selected
              ) {
                <div class="sub-marker">
                  <span>{{ marker.text }}</span>
                </div>
              }
            </div>
          </div>
        }

        @if (thumbnailLoading()) {
          <div class="thumbnailLoadingSpinnerWrapper">
            <app-spinner [black]="true"></app-spinner>
          </div>
        }
      </div>

      @if (
        !rotatingAssetDetails().length &&
        isRotating() &&
        !healthStatusEmptyResponse()
      ) {
        <app-spinner [black]="true"></app-spinner>
      }

      @if (rotatingAssetDetails().length > 0 && !healthStatusEmptyResponse()) {
        @for (rotatingAsset of rotatingAssetDetails(); track $index) {
          @if (
            asset() &&
            asset()?.notifications?.length > 0 &&
            asset()?.equipmentTypeID !== 113
          ) {
            @for (notification of Notifications(); track notification.id) {
              @if (notification.isCritical || notification.isWarning) {
                <app-notification-alert
                  [notification]="notification"
                  [notificationList]="false"
                >
                </app-notification-alert>
              }
            }
          }

          <div class="sensor-header">
            <i
              nz-icon
              [nzType]="'icons:pressure'"
              class="sensor-icon svg-icon"
            ></i>
            <h2>{{ i18n.langString("health_status") }}</h2>
            <div class="info-icon" (click)="openInfoPopup.set(true)">
              <i
                nz-icon
                [nzType]="'icons:info'"
                class="sensor-icon svg-icon"
              ></i>
            </div>
          </div>

          @if (loadingRotatingData() || isHealthStatusNotAvailable()) {
            <app-spinner [black]="true"></app-spinner>
          } @else {
            @if (isSystemStatusValidRotEq()) {
              <app-sensor-health-status
                [rotatingEqWorkingFine]="rotatingEqWorkingFine()"
                [rotatingEqWarning]="rotatingEqWarning()"
                [rotatingEqCritical]="rotatingEqCritical()"
                [rotatingEqInactive]="rotatingEqInactive()"
              >
              </app-sensor-health-status>
            } @else {
              <div class="health-status-offline">
                {{ rotatingAsset.systemStatusV2 }}
              </div>
            }
          }

          <div class="sensor-header">
            <i nz-icon [nzType]="'icons:tool'" class="sensor-icon svg-icon"></i>
            <h2>{{ i18n.langString("remaining_useful_life") }}</h2>
            <div class="info-icon" (click)="openInfoPopup.set(true)">
              <i
                nz-icon
                [nzType]="'icons:info'"
                class="sensor-icon svg-icon"
              ></i>
            </div>
          </div>

          <div class="rotating-equipment">
            <div class="rotating-equipment-inner-content">
              <span class="rotating-equipment-content-bold">{{
                i18n.langString("rul_bold_content")
              }}</span>
              <span class="rotating-equipment-content">{{
                i18n.langString("rul_content")
              }}</span>
            </div>
            <div class="rul-image">
              <nz-progress
                [nzPercent]="getRulPercentage(rotatingAsset.rul)"
                [nzSteps]="10"
                [nzStrokeColor]="
                  getProgressStrokeColor(getRulPercentage(rotatingAsset.rul))
                "
                [nzShowInfo]="false"
              >
              </nz-progress>
              <span
                >{{ getRulPercentage(rotatingAsset.rul) }}
                {{ i18n.langString("rul_image") }}
              </span>
            </div>
          </div>

          <div class="more-details">
            <app-nav-button
              [primary]="true"
              (clickEvent)="goToNanoPreciseDashboard()"
              svgIcon="icons:dashboard"
            >
              {{ i18n.langString("analyst_dashboard") }}
            </app-nav-button>
          </div>

          <app-additional-info-em
            [Sensor]="Sensor()"
            [groupedInfoValues]="groupedInfoValues()"
          >
          </app-additional-info-em>
        }
      }
      @if (rotatingAssetDetails().length === 0 && healthStatusEmptyResponse()) {
        <div class="empty_reponse_block">
          <div class="empty_response_icon">
            <i nz-icon nzType="icons:Toast" class="svg-icon fillwhite"></i>
          </div>
          <div class="empty_response_content">
            <h4>{{ i18n.langString("rotating_error_title") }}</h4>
            <p>{{ i18n.langString("rotating_error_text") }}</p>
          </div>
        </div>
      }
      @if (
        asset() &&
        asset()?.notifications?.length > 0 &&
        asset()?.equipmentTypeID !== 113 &&
        !isRotating()
      ) {
        @for (notification of Notifications(); track notification.id) {
          @if (notification.isCritical || notification.isWarning) {
            <app-notification-alert
              [notification]="notification"
              [notificationList]="false"
            >
            </app-notification-alert>
          }
        }
      }
      @if (
        asset() &&
        asset()!.notifications &&
        asset()!.notifications.length > 0 &&
        Sensor()
      ) {
        <div class="location-wrapper">
          <div class="sensor-header">
            <i
              nz-icon
              [nzType]="'icons:location'"
              class="sensor-icon svg-icon"
            ></i>
            <h2>{{ i18n.langString("location") }}</h2>
          </div>

          @if (breadcrumbsLoading()) {
            <div class="location-spinner-container">
              <app-spinner [black]="true"></app-spinner>
            </div>
          }

          <div class="location-content">
            @if (breadcrumbsLoading()) {
              <div class="location-spinner-container">
                <app-spinner [black]="true"></app-spinner>
              </div>
            }
            @if (asset().breadcrumbs && !breadcrumbsLoading()) {
              <nz-descriptions
                [nzColumn]="1"
                nzBordered
                [nzSize]="'small'"
                class="nzNotATable"
              >
                @for (breadcrumb of asset().breadcrumbs; track $index) {
                  @if ($index > 0) {
                    <nz-descriptions-item
                      [nzTitle]="i18n.parse(breadcrumb.layerName)"
                    >
                      <span
                        role="button"
                        tabindex="0"
                        [class.clickable]="isBreadcrumbClickable()"
                        (click)="navToBreadcrumb(breadcrumb)"
                        (keydown.enter)="navToBreadcrumb(breadcrumb)"
                        (keydown.space)="navToBreadcrumb(breadcrumb)"
                      >
                        {{ i18n.parse(breadcrumb.objectName) }}
                      </span>
                    </nz-descriptions-item>
                  }
                }
              </nz-descriptions>
            }
          </div>
        </div>
      }
      @if (Sensor()) {
        @if (Sensor()?.geoPosition) {
          <app-asset-overview-map
            [SensorPosition]="sensorGeoPosition()"
            [Sensor]="Sensor()"
          >
          </app-asset-overview-map>
        }
      }
      @if (Sensor()) {
        <div class="sensor-header flat-sensor">
          <i nz-icon [nzType]="'icons:graph'" class="sensor-icon svg-icon"></i>
          <div class="sensor-header-inner-div">
            <h2>{{ i18n.langString("sensor_data") }}</h2>
            <span class="black-coral-text body-bold">
              {{ Sensor()?.sensorDisplayLabel }}
            </span>
          </div>
        </div>
        @if (SensorDetailedTelemetry()?.length > 0) {
          <div class="sensordata-wrapper">
            <app-sensor-value
              [telemetry]="SensorDetailedTelemetry()[0]"
              [graphData]="getVisibleGraphs(SensorDetailedTelemetry()[0])[0]"
              [asHeader]="true"
            >
            </app-sensor-value>

            <div class="grapharea-wrapper">
              <app-tab-bar
                [opaque]="true"
                [icon]="false"
                (tabChanged)="
                  onTelemetryTimeframeSelect(
                    $event,
                    SensorDetailedTelemetry()[0]
                  )
                "
                [disabled]="
                  noDataTelemetry(SensorDetailedTelemetry()[0]) ||
                  graphBrushActive() ||
                  getTimeframe(SensorDetailedTelemetry()[0])?.custom
                "
              >
                <app-tab-bar-item
                  class="one-of-three"
                  [inactive]="
                    isTelemetryTimeframeCustom(SensorDetailedTelemetry()[0])
                  "
                >
                  {{ i18n.langString("days") }}
                </app-tab-bar-item>
                <app-tab-bar-item
                  class="one-of-three"
                  [inactive]="
                    isTelemetryTimeframeCustom(SensorDetailedTelemetry()[0])
                  "
                >
                  {{ i18n.langString("weeks") }}
                </app-tab-bar-item>
                <app-tab-bar-item
                  class="one-of-three"
                  [inactive]="
                    isTelemetryTimeframeCustom(SensorDetailedTelemetry()[0])
                  "
                >
                  {{ i18n.langString("months") }}
                </app-tab-bar-item>
              </app-tab-bar>

              @for (telemetry of SensorDetailedTelemetry(); track $index) {
                @if (!getVisibleGraphs(telemetry).length) {
                  <div class="graph-wrapper">
                    <app-spinner [black]="true"></app-spinner>
                  </div>
                }

                @for (data of getVisibleGraphs(telemetry); track $index) {
                  @if (data?.openRangePicker > 0) {
                    <div
                      class="range-picker-backdrop"
                      role="button"
                      tabindex="0"
                      (click)="cancelRangePick(data)"
                      (keydown.enter)="cancelRangePick(data)"
                      (keydown.space)="cancelRangePick(data)"
                    ></div>
                  }

                  @if ($index === 0) {
                    <div
                      class="range-picker-wrapper"
                      [class.disabled]="noDataTelemetry(telemetry)"
                    >
                      @if (isDesktop()) {
                        <nz-range-picker
                          [nzShowToday]="false"
                          [nzAllowClear]="false"
                          [nzPlaceHolder]="[
                            i18n.langString('start'),
                            i18n.langString('end'),
                          ]"
                          [nzDisabledDate]="rangePickerDisabledDate(data, 1)"
                          [(ngModel)]="range"
                          [id]="
                            'picker_start_' + data.metadata.measurementTypeID
                          "
                          (ngModelChange)="startonRangePickerSelect($event)"
                        >
                        </nz-range-picker>
                      } @else {
                        <nz-date-picker
                          [nzShowToday]="false"
                          [nzAllowClear]="false"
                          #datePick
                          [id]="
                            'picker_start_' + data.metadata.measurementTypeID
                          "
                          [nzDisabledDate]="rangePickerDisabledDate(data, 1)"
                          [(ngModel)]="range()[0]"
                          (ngModelChange)="
                            onRangeStartPick(
                              data.metadata.measurementTypeID,
                              Sensor()!.sensorID,
                              $event,
                              'picker_end_' + data.metadata.measurementTypeID,
                              data
                            )
                          "
                        >
                        </nz-date-picker>
                        <nz-date-picker
                          [nzShowToday]="false"
                          [nzAllowClear]="false"
                          #datePick
                          [id]="'picker_end_' + data.metadata.measurementTypeID"
                          [nzDisabledDate]="rangePickerDisabledDate(data, 2)"
                          [(ngModel)]="range()[1]"
                          (ngModelChange)="
                            onRangeEndPick(
                              data.metadata.measurementTypeID,
                              Sensor()!.sensorID,
                              $event,
                              data
                            )
                          "
                        >
                        </nz-date-picker>
                      }
                    </div>
                  }

                  <div class="hidden-graph">
                    @if (SensorDetailedTelemetry()?.length > 1) {
                      <div class="graph-separator"></div>
                      <p class="graph-title">
                        {{ i18n.parse(telemetry?.title) }} |
                        {{ telemetry.value.valStr }}
                      </p>
                    }

                    <div class="graph-wrapper">
                      @if (!data || !!data.loading) {
                        <app-spinner [black]="true"></app-spinner>
                      }
                      @if (!data?.error) {
                        <app-graph
                          [hasResetButton]="
                            $index === SensorDetailedTelemetry()?.length - 1
                          "
                          [Data]="data"
                          [class.hidden]="!!data.loading"
                          [Settings]="settings()"
                          (brushStateChange)="graphBrushActive.set($event)"
                          (timeframeUpdated)="dateRangeUpdatedfromGraph($event)"
                          [Timeframe]="getTimeframe(telemetry)"
                          [Type]="!!data.co_metadata ? 'multi-line' : 'line'"
                          (timeframeReset)="resetTimeframeSelect(telemetry)"
                        >
                        </app-graph>
                      } @else {
                        <span class="error">{{
                          i18n.langString("error_loading_data")
                        }}</span>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }
      }

      @if (!Sensor() && asset()?.equipmentTypeID !== 113) {
        @if (LoadingSensors()) {
          <div
            class="sensor-position-details"
            [class.desktop]="isDesktop()"
            [class.mobile]="!isDesktop()"
          ></div>
          <div class="sensor-header">
            <i nz-icon nzType="icons:pressure" class="sensor-icon svg-icon"></i>
            <h2>{{ i18n.langString("sensor_status") }}</h2>
          </div>
          <app-spinner [black]="true"></app-spinner>
        } @else {
          @for (group of !!asset() ? SensorTiles() : []; track $index) {
            @if (group && i18n.parse(group?.title) !== "Temperature") {
              <div
                class="sensor-position-details"
                [class.desktop]="isDesktop()"
                [class.mobile]="!isDesktop()"
              >
                @if (IsPipe()) {
                  <div class="image">
                    <img
                      nz-image
                      nzDisablePreview
                      class="find-sensor-image"
                      [nzSrc]="
                        isDesktop()
                          ? 'assets/images/Underground.png'
                          : 'assets/images/Aboveground.png'
                      "
                      alt="Find Sensor"
                    />
                  </div>
                  <div class="content">
                    <div class="info-icon">
                      <img
                        nz-image
                        nzDisablePreview
                        class="find-sensor-image"
                        [nzSrc]="'assets/icons/info.svg'"
                        alt="Find Sensor"
                      />
                    </div>
                    <div class="find-sesor-description">
                      <strong>{{ i18n.langString("Find_sensor_ques") }}</strong>
                      {{ i18n.langString("Find_sensor_position") }}
                    </div>
                  </div>
                }
              </div>

              <div class="sensor-header">
                <i
                  nz-icon
                  [nzType]="'icons:' + group.icon"
                  class="sensor-icon svg-icon"
                ></i>
                <h2>{{ i18n.langString("sensor_status") }}</h2>
              </div>

              <div class="tile-wrapper">
                @for (telemetry of group.telemetry; track telemetry) {
                  <app-tile
                    [telemetry]="telemetry"
                    [isSteamTrap]="HasSteamTrapAnalytics()"
                    [isLeakageSensor]="HasLeakageSensors()"
                    [class.steamTrap]="HasSteamTrapAnalytics()"
                    [isSteamTrapInletOutlet]="
                      IsSteamTrap() && !HasSteamTrapAnalytics()
                    "
                    [steamtrap_outlet]="SteamTrapOutlet()"
                    [asset]="asset()"
                    (click)="onSensorSelect(telemetry?.sensor?.sensorID)"
                  >
                  </app-tile>
                }
              </div>
            }
          }
        }
      }
      @if (
        !Sensor() && HasSteamTrapAnalytics() && asset()?.equipmentTypeID !== 113
      ) {
        <div class="sensor-header flat-sensor">
          <i
            nz-icon
            [nzType]="'icons:pressure'"
            class="sensor-icon svg-icon"
          ></i>
          <div class="sensor-header-inner-div">
            <h2>{{ i18n.langString("steam_trap_monitoring") }}</h2>
            @if (showHighTempText()) {
              <span class="detail lighter-label">
                {{ i18n.langString("high_heat_resistance") }}
              </span>
            }
          </div>
        </div>

        <app-steam-trap-analytics
          [GraphDisplays]="SteamTrapGraphDisplays()"
          [GraphData]="SteamTrapGraphData()"
          [SteamLossPrediction]="SteamLossPrediction()"
          [loading]="SteamTrapAnalyticsLoading()"
          [SteamTrapTelemetry]="SteamTrapTelemetry()"
          [isTelemetryTimeframeCustom]="IsTelemetryTimeframeCustom()"
          [Range]="Range()"
          [settings]="settings()"
          [NoPricePerTon]="SteamTrapNoPricePerTon()"
          [SteamLossCurrencyUnit]="SteamLossCurrencyUnit()"
          (OnTelemetryTimeframeSelect)="
            onTelemetryTimeframeSelect($event.index, $event.telemetry)
          "
          (dateRangeUpdatedfromGraph)="dateRangeUpdatedfromGraph($event)"
          (OnRangeStartPick)="
            onRangeStartPick(
              $event.measurementTypeID,
              $event.sensorID,
              $event.event,
              $event.endPickerID,
              $event.data
            )
          "
          (OnRangeEndPick)="
            onRangeEndPick(
              $event.measurementTypeID,
              $event.sensorID,
              $event.event,
              $event.data
            )
          "
          (OpenRangePicker)="openRangePicker($event.id, $event.data)"
          (OnRangePickerSelect)="startonRangePickerSelect($event.event)"
        >
        </app-steam-trap-analytics>
      }
      @for (group of asset() && !Sensor() ? Temperature() : []; track $index) {
        <div class="sensor-header flat-sensor">
          <i
            nz-icon
            [nzType]="'icons:' + group.icon"
            class="sensor-icon svg-icon"
          ></i>
          <div class="sensor-header-inner-div">
            <h2>{{ i18n.langString("temperature_of_the_edge_device") }}</h2>
          </div>
        </div>

        @for (telemetry of group.telemetry; track telemetry.sensor.sensorID) {
          <div aria-label="temperature detail" class="edgeTemperatureButton">
            <app-sensor-value
              [telemetry]="telemetry"
              (click)="
                toSensorValue(
                  telemetry.sensor.sensorID,
                  telemetry.measurementTypeID
                )
              "
            >
            </app-sensor-value>
          </div>
        }
      }

      @if (historyItems().length && Sensor() && !isRotating()) {
        <div class="history-wrapper">
          <div class="sensor-header flat-sensor">
            <i nz-icon nzType="icons:history" class="sensor-icon svg-icon"></i>
            <div class="sensor-header-inner-div">
              <h2>{{ i18n.langString("history") }}</h2>
              @if (Sensor()) {
                <span class="black-coral-text body-bold">
                  {{ Sensor()?.sensorDisplayLabel }}
                </span>
              }
            </div>
          </div>

          <div class="history">
            <nz-list nzBordered [nzFooter]="historyfooter" class="history-list">
              @if (loadingHistory()) {
                <div class="history-spinner">
                  <app-spinner [black]="true"></app-spinner>
                </div>
              }

              @for (item of HistoryItems().slice(0, 6); track item) {
                <nz-list-item>
                  <app-history-item
                    [dateFormat]="settings().DateFormat"
                    [item]="item"
                    [asset]="asset()"
                  >
                  </app-history-item>
                </nz-list-item>
              }
            </nz-list>

            <ng-template #historyfooter>
              <div class="history-footer-item">
                <app-nav-button
                  [darksecondary]="true"
                  svgIcon="icons:documentation"
                  (clickEvent)="overlayDocumentation.set(true)"
                >
                  {{ i18n.langString("add_documentation") }}
                </app-nav-button>

                @if (overlayDocumentation()) {
                  <app-docu-wizard
                    [assetId]="asset()?.objectID"
                    [sensorId]="selectedSensor()"
                    (saved)="onDocumentationAdded()"
                    (closeEvent)="overlayDocumentation.set(false)"
                  >
                  </app-docu-wizard>
                }
              </div>

              <div class="history-footer-item">
                <app-nav-button
                  [primary]="true"
                  svgIcon="icons:eye"
                  [disabled]="!HistoryItems() || HistoryItems().length === 0"
                  (clickEvent)="
                    toSensorHistory(!!Sensor() ? Sensor().sensorID : null)
                  "
                >
                  {{ i18n.langString("show_all_entries") }}
                </app-nav-button>
              </div>
            </ng-template>
          </div>
        </div>
      }

      @if (historyItems().length > 0 && isRotating()) {
        <div class="history-wrapper">
          <div class="sensor-header flat-sensor">
            <i nz-icon nzType="icons:history" class="sensor-icon svg-icon"></i>
            <div class="sensor-header-inner-div">
              <h2>{{ i18n.langString("history") }}</h2>
              @if (Sensor()) {
                <span class="black-coral-text body-bold">
                  {{ Sensor()?.sensorDisplayLabel }}
                </span>
              }
            </div>
          </div>

          <div class="history">
            <nz-list nzBordered [nzFooter]="historyfooter" class="history-list">
              @for (item of HistoryItems().slice(0, 6); track item) {
                <nz-list-item>
                  <app-history-item
                    [dateFormat]="settings().DateFormat"
                    [item]="item"
                    [asset]="asset()"
                  >
                  </app-history-item>
                </nz-list-item>
              }
            </nz-list>

            <ng-template #historyfooter>
              <div class="history-footer-item">
                <app-nav-button
                  [primary]="true"
                  svgIcon="icons:eye"
                  [disabled]="!HistoryItems() || HistoryItems().length === 0"
                  (clickEvent)="
                    toSensorHistory(!!Sensor() ? Sensor().sensorID : null)
                  "
                >
                  {{ i18n.langString("show_all_entries") }}
                </app-nav-button>
              </div>
            </ng-template>
          </div>
        </div>
      }

      @if (
        asset() &&
        (!asset()?.notifications ||
          asset()?.notifications.length === 0 ||
          !Sensor()) &&
        asset()?.equipmentTypeID !== 113
      ) {
        <div class="location-wrapper">
          <div class="sensor-header">
            <i nz-icon nzType="icons:location" class="sensor-icon svg-icon"></i>
            <h2>{{ i18n.langString("location") }}</h2>
          </div>

          @if (breadcrumbsLoading()) {
            <div class="location-spinner-container">
              <app-spinner [black]="true"></app-spinner>
            </div>
          }

          <div class="location-content">
            @if (breadcrumbsLoading()) {
              <div class="location-spinner-container">
                <app-spinner [black]="true"></app-spinner>
              </div>
            }

            @if (asset()?.breadcrumbs && !breadcrumbsLoading()) {
              <nz-descriptions
                [nzColumn]="1"
                nzBordered
                [nzSize]="'small'"
                class="nzNotATable"
              >
                @for (breadcrumb of asset()?.breadcrumbs; track $index) {
                  @if ($index > 0) {
                    <nz-descriptions-item
                      [nzTitle]="i18n.parse(breadcrumb.layerName)"
                    >
                      <span
                        role="button"
                        tabindex="0"
                        [class.clickable]="isBreadcrumbClickable()"
                        (click)="navToBreadcrumb(breadcrumb)"
                        (keydown.enter)="navToBreadcrumb(breadcrumb)"
                        (keydown.space)="navToBreadcrumb(breadcrumb)"
                      >
                        {{ i18n.parse(breadcrumb.objectName) }}
                      </span>
                    </nz-descriptions-item>
                  }
                }
              </nz-descriptions>
            }
          </div>
        </div>
      }
      <app-additional-info-em
        [asset]="asset()"
        [Sensor]="Sensor()"
        [groupedInfoValues]="groupedInfoValues()"
      >
      </app-additional-info-em>

      <app-sensor-subscription
        [sensor]="Sensor()"
        [dateFormat]="settings().DateFormat"
      >
      </app-sensor-subscription>

      @if (asset() && !Sensor() && SensorHealth().length) {
        <button class="ga-sensor-health-btn" (click)="toSensorHealth()">
          <h4>{{ i18n.langString("show_sensor_health") }}</h4>
          <div>
            @if (isSensorHealthCrit()) {
              <div class="ga-sensor-health-check detail-bold">
                <i
                  nz-icon
                  nzType="icons:status-exclamation-triangle"
                  class="mini-svg-icon fillred"
                ></i>
                <span>{{ i18n.langString("please_check") }}</span>
              </div>
            } @else if (isSensorHealthWarning()) {
              <div class="ga-sensor-health-check-warning detail-bold">
                <i
                  nz-icon
                  nzType="icons:status-exclamation-octagon"
                  class="mini-svg-icon fillyellow"
                ></i>
                <span>{{ i18n.langString("please_check") }}</span>
              </div>
            } @else {
              <div class="ga-sensor-health-fine detail-bold">
                <i
                  nz-icon
                  nzType="icons:status-check"
                  class="mini-svg-icon fillgreen"
                ></i>
                <span>{{ i18n.langString("working_fine") }}</span>
              </div>
            }

            <div class="ga-sensor-health-time detail-bold">
              <i
                nz-icon
                nzType="icons:refresh"
                class="mini-svg-icon fillblackcoral"
              ></i>
              <span class="align-right">
                {{
                  lastChecked()
                    ? i18n.langString("ago1") +
                      lastChecked() +
                      i18n.langString("ago2")
                    : i18n.langString("never_checked")
                }}
              </span>
            </div>
          </div>
        </button>
      }

      <div class="techmargin">
        @if (
          asset()?.equipmentType === "Steam Trap" ||
          asset()?.equipmentType === "Flange" ||
          asset()?.equipmentType === "Rotating Equipment"
        ) {
          <app-nav-button
            [darksecondary]="true"
            svgIcon="icons:tool"
            (clickEvent)="toTechnicalDocuments()"
          >
            {{ i18n.langString("view_technical_documents") }}
          </app-nav-button>
        }
      </div>
    </div>
  }
</div>

@if (openInfoPopup()) {
  <app-health-status-info-popup
    (closeButton)="closeHealthInfo()"
    [modalOpen]="openInfoPopup()"
    [asset]="asset()"
  >
  </app-health-status-info-popup>
}
